import { createFileRoute, Outlet } from '@tanstack/react-router'

// Access is enforced by the central route guard in __root.tsx (telephony:admin)
export const Route = createFileRoute('/admin/telephony')({
  component: Outlet,
})
